<template>
  <div
    :class="
      index == 2
        ? 'rank-top-card-left'
        : index == 1
        ? 'rank-top-card-center'
        : 'rank-top-card-right'
    "
  >
    <div class="rank-top-card-content">
      <img :src="OSS_BASE + '/market/img/rank/00' + index + '.png'" />
      <div class="rank-top-time">
        {{ item && item.score ? item.score + "s" : "" }}
      </div>
      <div class="rank-top-name">
        {{ item && item.user && item.user.nickname ? item.user.nickname : "" }}
      </div>
    </div>
  </div>
  <!-- <div class="rank-top-card-left">
            <div class="rank-top-card-content">
              <img :src="OSS_BASE + '/market/img/rank/002.png'" />
              <div class="rank-top-time">48s</div>
              <div class="rank-top-name">user name</div>
            </div>
          </div>
          <div class="rank-top-card-center">
            <div class="rank-top-card-content">
              <img :src="OSS_BASE + '/market/img/rank/001.png'" />
              <div class="rank-top-time">48s</div>
              <div class="rank-top-name">user name</div>
            </div>
          </div>
          <div class="rank-top-card-right">
            <div class="rank-top-card-content">
              <img :src="OSS_BASE + '/market/img/rank/003.png'" />
              <div class="rank-top-time">48s</div>
              <div class="rank-top-name">user name</div>
            </div>
          </div> -->
</template>

<script>
export default {
  props: ["index", "item"],
  data() {
    return {
      OSS_BASE
    };
  },
  created() {},
  methods: {},
};
</script>

<style>
.rank-top-card-left,
.rank-top-card-right {
  padding-top: 22%;
  width: 30%;
}
.rank-top-card-center {
  width: 33.6%;
}
.rank-top-card-content {
  position: relative;
}
.rank-top-time {
  color: #ffd75b;
  position: absolute;
  left: 50%;
  top: 64%;
  transform: translate(-50%, 0);
  text-align: center;
  font-size: 15px;
}
.rank-top-card-center .rank-top-time {
  color: #dd5a00;
  padding-left: 4px;
}
.rank-top-name {
  text-align: center;
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 320px;
}

@media screen and (max-width: 414px) {
  .rank-top-time {
    top: 63%;
  }
  .rank-top-card-center .rank-top-time {
    top: 64%;
  }
}
@media screen and(max-width:375px) {
  .rank-top-time {
    /* top: 62%; */
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/maze/rankItemTop.vue